'use client';

import { ReactNode } from 'react';
import { Container } from './Container';
import { cn } from '@workspace/ui/lib/utils';
import { useProfileUIStore } from '@/src/sections/profile/store/profile-ui-store';

export const MainWrapper = ({ children, style }: { children: ReactNode; style?: React.CSSProperties }) => {
  const isMobileView = useProfileUIStore(state => state.isMobileView);

  return (
    <Container
      className={cn('w-full pt-5 min-h-[calc(100vh-140px)] flex', {
        'md:pl-9 md:pt-4 md:pr-4 md:pb-0': !isMobileView,
      })}
      style={style}
    >
      <main
        className={cn('flex-1 flex overflow-hidden justify-center', {
          'max-w-[320px] mx-auto custom-border rounded-[36px] bg-white px-1 pt-5':
            isMobileView,
        })}
      >
        {children}
      </main>
    </Container>
  );
};
